import "./styles/quasar.sass";
import "@quasar/extras/material-icons/material-icons.css";

// To be used on app.use(Quasar, { ... })
export default {
  config: {},
  plugins: {
    brand: {
      primary: "#144553",
      secondary: "#D1F994",
      accent: "#75634f",
    },
  },
};
